import { render, staticRenderFns } from "./update-passwd.vue?vue&type=template&id=f1cea35e&"
import script from "./update-passwd.vue?vue&type=script&lang=js&"
export * from "./update-passwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "update-passwd.vue"
export default component.exports